export default "__VITE_ASSET__QEs_Gjzl__"